import { Button } from '@qodo/design-system';
import i18n from 'i18next';
import { ExternalLink } from 'lucide-react';
import { InstallationStatusMessage } from 'shared/InstallationDialog';
import { spawn } from 'utils/translations';
import { openUrl } from 'utils/url';

type ErrorStatusMessageProps = {
  message: string;
  retryLabel: string;
  onRefetch: () => void;
  urlLink: string;
  detail?: string;
};

export const ErrorStatusMessage = ({
  message,
  retryLabel,
  onRefetch,
  urlLink,
  detail,
}: ErrorStatusMessageProps) => {
  const spawnConsent = spawn('dialogs.azure-installation.consent');
  const consentKey = `dialogs.azure-installation.consent.${detail}`;
  const detailErrorMessage =
    detail && (i18n.exists(consentKey) ? spawnConsent(detail) : detail);

  const onOpenDocumentation = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    openUrl(urlLink, true);
  };

  return (
    <>
      <InstallationStatusMessage
        status="error"
        message={message}
        retryLabel={retryLabel}
        onRetry={onRefetch}
        detail={detailErrorMessage}
      />
      <div className="flex justify-end">
        <Button
          variant="link"
          onClick={onOpenDocumentation}
          size="sm"
          iconPosition="right"
          icon={ExternalLink}
        >
          {spawnConsent('need-help')}
        </Button>
      </div>
    </>
  );
};
